var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBottomArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.99129e-07 5.05554L0.913449 4.15111L3.84994 7.0586L3.83313 0.5L5.14446 0.5L5.16127 7.0586L8.10336 4.15111L9 5.03889L4.4944 9.5L-1.98886e-07 5.04999L-1.99129e-07 5.05554Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBottomArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bottom-arrow.79a646ed8b82752e954f1cf4fb41a002.svg";